export default import.meta.ROLLDOWN_FILE_URL_lpTEiE1r1SNpLPNwP3j6$w